import React from "react";
import { FaArrowRightLong } from "react-icons/fa6";
import { messageicon } from "../../../assets/icons";
import { Link, useNavigate } from "react-router-dom";
import useSnackbar from "../../../hooks/useSnackbar";
import { AuthService } from "../../../services";
import { joiResolver } from "@hookform/resolvers/joi";
import { sendEmailOtpValidation } from "../../../validations";
import { useMutation } from "@tanstack/react-query";
import { useForm } from "react-hook-form";
import ButtonLoader from "../../../component/buttonLoader";

const Email = () => {
  const navigate = useNavigate();
  const { snackbar } = useSnackbar();
  const { sendOtp } = AuthService();
  const {
    register,
    getValues,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: joiResolver(sendEmailOtpValidation),
    defaultValues: {
      email: "",
    }
  });

  const sendOtpMutation = useMutation({
    mutationFn: (data) => {
      return sendOtp({ ...data, type: "reset_password" });
    },
    onSuccess: (data) => {
      navigate("/otp", {
        state: {
          ...getValues(),
          screen: "forgot"
        }
      })
      snackbar((data?.message || ""), "info");
    },
    onError: (err) => {
      snackbar((err.data.message || ""));
    }
  });


  return (
    <div className="signup_wrap">
      <form onSubmit={handleSubmit(sendOtpMutation.mutate)}>
        <div className="form_field icon_set">
          <label className="label" htmlFor="">
            Email Address
          </label>
          <input
            {...register("email")}
            type="email"
            className="input form-control"
            placeholder="Enter Your Email"
          />
          <img src={messageicon} alt="icon" />
          {errors.email && <span className="error">{errors.email?.message}</span>}
        </div>

        <div className="btn_wrap_login">
          <ButtonLoader
            text={<>Verify <FaArrowRightLong /></>}
            className="login"
            isLoading={sendOtpMutation.isPending}
          />
        </div>
      </form>
    </div>
  );
};

export default Email;
